export default 'Estimateur CEE 60 sec, calculateur MaPrimeRénov’, comparateur énergie B2B, audit Décret Tertiaire — accès libre, sans inscription. Personnalisé selon votre profil.';
